import React from 'react';
import { Center, SegmentedControl } from '@good/ui/core';
import { BookingsViewLayoutType } from './types';
import { Grid2Vertical, Grid5Vertical } from '@good/icons';

interface LayoutTypeSegmentedControlProps {
  value: BookingsViewLayoutType;
  onChange: (value: BookingsViewLayoutType) => void;
}

export const LayoutTypeSegmentedControl = ({ value, onChange }: LayoutTypeSegmentedControlProps) => {
  return (
    <SegmentedControl
      variant='default'
      value={value}
      data={[
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Grid5Vertical />
            </Center>
          ),
          value: 'regular',
        },
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Grid2Vertical />
            </Center>
          ),
          value: 'compact',
        },
      ]}
      onChange={(value) => onChange(value as BookingsViewLayoutType)}
    />
  );
};
